// 文章與對話錄的內文先到（2026-09-25 動態設計 P5）。
// 舊版：頁面掛載後才 import 內文 JSON，先淡入「Loading…」、頁尾閃進畫面中段，內文再硬切進來把頁尾推走（CLS 0.60／0.89）。
// 新版：導航在 beforeResolve 就把內文載好（滑過連結時也會先預載），頁面掛載當下內文已經在。
const loaders = {
  article: slug => import(`@/data/articles/${slug}.json`),
  dialogue: slug => import(`@/data/dialogues/${slug}.json`),
}
const kinds = { pageWritingDetail: 'article', pageDialogueDetail: 'dialogue' }
const pending = new Map(), loaded = new Map()

export function loadContent(kind, slug) {
  const key = kind + ':' + slug
  if (!pending.has(key)) {
    const promise = loaders[kind](slug).then(module => {
      const value = module.default || module
      loaded.set(key, value)
      return value
    })
    promise.catch(() => pending.delete(key))
    pending.set(key, promise)
  }
  return pending.get(key)
}

export const peekContent = (kind, slug) => loaded.get(kind + ':' + slug)

// 路由守衛與預載共用：失敗不擋導航（頁面自己會顯示找不到）
export function preloadRouteContent(route) {
  const kind = kinds[route?.meta?.publicEntry?.component]
  const slug = route?.params?.slug
  if (!kind || typeof slug !== 'string') return
  return loadContent(kind, slug).then(() => {}, () => {})
}
